var _path, _path2, _path3, _g, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.723 32.202l-.088-.806h-7.238c-50.359 0-35.283 57.41-35.283 57.41H76.69l11.704-51.804-43.671-4.8z",
    fill: "#d2d2d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427.538 423.195c-20.076-121.131 20.525-391.798-52.966-391.798H37.398c94.676 0 0 449.207 89.64 449.207h21.516l11.59-4.921-3.636-.709 271.03-51.779z",
    fill: "#efedee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.039 480.605c50.359 0 35.283-57.41 35.283-57.41h337.175s15.077 57.41-35.283 57.41H127.039z",
    fill: "#d2d2d2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3a484a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.786 123.178H127.038a7.725 7.725 0 01-7.726-7.726 7.725 7.725 0 017.726-7.726h106.748a7.725 7.725 0 017.726 7.726 7.725 7.725 0 01-7.726 7.726zM378.885 383.084h-57.148a7.725 7.725 0 01-7.726-7.726 7.725 7.725 0 017.726-7.726h57.148a7.726 7.726 0 110 15.452zM364.196 169.36H127.038c-4.268 0-7.726-3.459-7.726-7.726s3.458-7.726 7.726-7.726h237.158c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726zM364.196 211.374H127.038a7.725 7.725 0 01-7.726-7.726 7.725 7.725 0 017.726-7.726h237.158a7.725 7.725 0 017.726 7.726 7.725 7.725 0 01-7.726 7.726zM312.624 253.389H127.038c-4.268 0-7.726-3.459-7.726-7.726s3.458-7.726 7.726-7.726h185.585c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.725 7.726z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M368.461 124.292c-45.397 45.397-72.058 98.899-75.709 143.539 44.64-3.65 98.143-30.312 143.539-75.709S508.35 93.223 512 48.583c-44.639 3.651-98.143 30.312-143.539 75.709z",
    fill: "#f2c42c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M266.934 301.376a7.726 7.726 0 01-5.464-13.189l180.143-180.143a7.727 7.727 0 0110.927 10.926L272.398 299.112a7.7 7.7 0 01-5.464 2.264z",
    fill: "#e0b629"
  })));
}

export default __webpack_public_path__ + "0240d53899c4b292ec417b3015d44660.svg";
export { SvgLogs as ReactComponent };